import script from "./DataInconsistencyHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataInconsistencyHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DataInconsistencyHeader.vue?vue&type=style&index=0&id=526c052a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-526c052a"]])

export default __exports__